import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { OrgBoardAPI } from '@business/api/org_board';
import { OrgBoardRevisionsResponse, OrgRevId } from '@business/entities/org_board';

export class OrgBoardRevisionBloc extends BaseBloc {
  private readonly orgBoardRepo = new Repository<OrgBoardRevisionsResponse>({
    getItemId: orgBoardRevision => orgBoardRevision.id,
  });

  readonly orgBoardRevision$ = this.orgBoardRepo.items$;
  readonly selectOrgBoardRevision = this.orgBoardRepo.selectItem;

  onReset() {
    this.orgBoardRepo.reset();
  }

  fetchOrgBoardRevisions = () => {
    return OrgBoardAPI.fetchOrgBoardRevisions().pipe(
      this.orgBoardRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_org_board_error') }),
    );
  };
}
